export const sanitizeGradientId = (id: string): string => {
  return id.replace(/[^a-zA-Z0-9]/g, '').trim();
};
